import { render, staticRenderFns } from "./VideosPlaylistsSettings.vue?vue&type=template&id=3c81fe44&scoped=true"
import script from "./VideosPlaylistsSettings.vue?vue&type=script&lang=js"
export * from "./VideosPlaylistsSettings.vue?vue&type=script&lang=js"
import style0 from "./VideosPlaylistsSettings.vue?vue&type=style&index=0&id=3c81fe44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c81fe44",
  null
  
)

export default component.exports